import React from 'react';
import type { ChatMessage } from '@/features/chat/chatSlice';

interface MessageBubbleProps {
  message: ChatMessage;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isUser = message.sender === 'user';

  return (
    <div
      className={`max-w-[75%] px-3 py-2 rounded-2xl transition-all animate-fadeIn ${
        isUser ? 'ml-auto bg-blue-800 text-white' : 'mr-auto bg-slate-50 text-slate-800'
      }`}
    >
      {message.text}
    </div>
  );
};

export default MessageBubble;
